import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
// import { FaPlus } from 'react-icons/fa';
import {
  Button, Col, Form, Modal, Row, Spinner,
} from 'react-bootstrap';
import useAuth from '../../hooks/useAuth';
import { customTotal, pageButtonRenderer } from '../../common/constants';
import UserCard from '../../components/userCard';
import axiosCore from '../../common/axiosCore';
import { logout } from '../../services/MockAuthService';
import IdleTimer from '../../services/idleTimer';
import AlertTimeout from '../../components/alertTimeout';

function Complaint() {
  const title = 'Complaint';
  const { getSession } = useAuth();
  const { getMemberProfile } = useAuth();
  const member = getMemberProfile();
  const navigate = useNavigate();
  const user = getSession();
  const [show, setShow] = useState(false);
  const [subject, setSubject] = useState();
  const [message, setMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isWaiting, setIsWaiting] = useState(true);
  const [crmList, setCrmList] = useState([]);
  const [catchError, setIsCatchError] = useState('');
  const [isAlert, setIsAlert] = useState(false);
  const [isError, setIsError] = useState(false);

  const [isTimeout, setIsTimeout] = useState(false);
  const handleLogout = async () => {
    await logout();
    navigate('/');
    setIsTimeout(true);
  };
  useEffect(() => {
    const timer = new IdleTimer({
      // expire after 10 seconds
      timeout: 180,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        // do something if expired on load
        handleLogout().then();
      },
    });

    return () => {
      timer.cleanUp();
    };
  }, []);

  const crmListRequest = () => {
    setTimeout(() => {
      axiosCore.post('/member-module/crm/list-my-crm', {
        MemberId: member.MemberId,
      }).then((result) => {
        if (result.data.status !== 0) {
          setIsWaiting(false);
          setCrmList(result.data.data);
        }
        if (result.data.status === 0) {
          setIsWaiting(false);
          setCrmList(result.data.data);
        }
      }).catch((err) => {
        setIsCatchError(err.message);
        setIsError(true);
      });
    }, 2000);
  };

  useEffect(() => {
    crmListRequest();
    const interval = setInterval(() => {
      crmListRequest();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const columns = [
    {
      dataField: 'CREATE_DATE',
      text: 'Date',
    },
    {
      dataField: 'QID',
      text: 'Query ID',
    },
    {
      dataField: 'SUBJECT',
      text: 'Subject',
    },
    {
      dataField: 'QUERY_CATEGORY',
      text: 'Category',
    },
    {
      dataField: 'QUERY_STATUS',
      text: 'Status',
    },
  ];

  const options = {
    pageButtonRenderer,
    paginationSize: 4,
    pageStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: 'First',
    prePageText: 'Back',
    nextPageText: 'Next',
    lastPageText: 'Last',
    nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    lastPageTitle: 'Last page',
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [{
      text: '5', value: 5,
    }, {
      text: '10', value: 10,
    }, {
      text: 'All', value: crmList.length,
    }], // A numeric array is also available. the purpose of above example is custom the text
  };

  const crmListTable = () => {
    if (crmList.length > 0) {
      return <span>
        <div className="table-responsive">
        <BootstrapTable
          bootstrap4
          keyField='QID'
          data={ crmList }
          columns={ columns }
          pagination={ paginationFactory(options) }
          striped
          hover
          condensed
        />
      </div>
      </span>;
    }
    return <span>
      {!isWaiting && <p className="text-center">No complaints</p>}
    </span>;
  };

  const onCancel = () => {
    const timer = new IdleTimer({
      // expire after 10 seconds
      timeout: 180,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        // do something if expired on load
        handleLogout().then();
        setIsTimeout(true);
      },
    });
    setIsTimeout(false);
    return () => {
      timer.cleanUp();
    };
  };

  if (user) {
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <main className="container">
          <Breadcrumb>
            <Breadcrumb.Item><Link to="/console/dashboard">Dashboard</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>{title}</Breadcrumb.Item>
          </Breadcrumb>
          <div className="row">
            <div className="col">
              <h1 className="page-title">{title}</h1>
            </div>
            <div className="col">
               {/* <button type="button" className="btn btn-claim mb-3" onClick={handleShow}><FaPlus/> New Complaint </button> */}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 rounded">
              <UserCard/>
            </div>
            <div className="col-lg-8 rounded">
              <div className="card">
                <h6 className="card-header d-flex justify-content-between align-items-center">
                  Complaints
                </h6>
                <div className="card-body m-0">
                  {isWaiting && <p className="text-center">
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      hidden={!isWaiting}/> Please wait...</p>}
                  <div className="table-responsive">
                    {crmListTable()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Complaint Form</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form >
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label column sm="2">
                  <strong>FROM:</strong>
                </Form.Label>
                <Col sm="10">
                  <Form.Control plaintext readOnly defaultValue={user.FULL_NAME} />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label column sm="2">
                  <strong>TO:</strong>
                </Form.Label>
                <Col sm="10">
                  <Form.Control plaintext readOnly defaultValue="NSSF Customer Service" />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                <Form.Label column sm="2">
                  <strong>SUBJECT:</strong>
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    type="text"
                    name='subject'
                    className='form-control'
                    required='required'
                    value={subject}
                    id='id_subject'
                    onChange={(e) => setSubject(e.target.value)}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                <Form.Label column sm="2">
                  <strong>MESSAGE:</strong>
                </Form.Label>
                <Col sm="10">
                  <Form.Control
                    type="text"
                    name='subject'
                    as="textarea"
                    rows={3}
                    className='form-control'
                    required='required'
                    value={message}
                    id='id_subject'
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </Col>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button className='btn btn-light' onClick={handleClose}>
              Close
            </Button>
            <Button className='btn btn-green' onClick={handleClose}>
              Submit Complaint
            </Button>
          </Modal.Footer>
        </Modal>
        {isTimeout
        && <AlertTimeout onConfirm={handleLogout} onCancel={onCancel}/>
        }
      </>
    );
  }
  navigate('/login');
}
export default Complaint;
